import type { CacheDefinition, EncounterReward, MerchantDefinition } from '../../shared/game/supply-types.js';
import { coastEncounters, type EncounterPlan } from '../encounters/coast-encounters.js';

// Small-town merchants sell only items worth 50 gp or less (Core Rules p. 37); dearer potions need a larger market.
export const emberCoastMerchants: MerchantDefinition[] = [
  { id: 'crossroads-peddler', name: 'Crossroads Peddler', x: 17, z: 13, stock: [{ itemId: 'healing-potion', price: 50, quantity: 4 }, { itemId: 'medical-kit', price: 20, quantity: 3 }, { itemId: 'torch', price: .2, quantity: 8 }] },
  { id: 'greywake-apothecary', name: 'Greywake Apothecary', x: -150, z: -38, stock: [
    { itemId: 'healing-potion', price: 50, quantity: 2 }, { itemId: 'greater-healing-potion', price: 150, quantity: 1 }, { itemId: 'medical-kit', price: 20, quantity: 2 }] },
];

export const emberCoastCaches: CacheDefinition[] = [
  { id: 'camp-stores', name: 'Abandoned camp stores', x: 30, z: -10, contents: { gold: 6, items: { 'healing-potion': 1 } } },
  { id: 'cart-crate', name: 'Spilled cart crate', x: 16, z: 21, contents: { gold: 8, items: {} } },
  { id: 'chapel-offering', name: 'Chapel offering box', x: -110, z: -322, contents: { gold: 10, items: { 'healing-potion': 1 } } },
  { id: 'keepers-locker', name: 'Keeper’s locker', x: -204, z: 200, contents: { gold: 12, items: { 'healing-potion': 1 } } },
  { id: 'roadside-strongbox', name: 'Roadside strongbox', x: 160, z: 58, contents: { gold: 15, items: { 'medical-kit': 1 } } },
  { id: 'mill-sacks', name: 'Mill grain sacks', x: 140, z: 312, contents: { gold: 10, items: {} } },
  { id: 'stones-offering', name: 'Windward offering', x: 392, z: 318, contents: { gold: 0, items: { 'greater-healing-potion': 1 } } },
  { id: 'smugglers-hoard', name: 'Smugglers’ hoard', x: 518, z: -228, contents: { gold: 35, items: {} } },
];

// Authored, not rolled. A crew's purse follows its difficulty (bandits carry what they stole, GMG p. 31); stronger crews also carry
// potions as rewards for optional risks. `loot` on a plan adds extras on top.
const PURSE: Record<EncounterPlan['difficulty'], Reward> = {
  easy: { gold: 8, items: {} }, medium: { gold: 14, items: {} },
  hard: { gold: 22, items: { 'healing-potion': 1 } }, deadly: { gold: 40, items: { 'greater-healing-potion': 1 } },
  'very-deadly': { gold: 60, items: { 'greater-healing-potion': 2 } },
};
type Reward = { gold: number; items: Record<string, number> };
export const emberCoastRewards: EncounterReward[] = coastEncounters.map(plan => {
  const items: Record<string, number> = { ...PURSE[plan.difficulty].items };
  for (const [id, count] of Object.entries(plan.loot ?? {})) items[id] = (items[id] ?? 0) + count;
  return { encounterId: plan.id, contents: { gold: PURSE[plan.difficulty].gold, items } };
});
